import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { useToast } from '@/components/ui/toast';

type Args = { id: string; file: globalThis.File };

async function upload({ id, file }: Args): Promise<void> {
  const form = new globalThis.FormData();
  form.append('photo', file);
  await pb.send(`/api/team-members/verification-photo/${id}`, {
    method: 'POST',
    body: form,
  });
}

function uploadErrorMessage(err: unknown): string {
  const raw = (err as { response?: { error?: string } })?.response?.error ?? '';
  if (/maximum allowed file size/i.test(raw)) {
    return 'La foto pesa más de 5 MB. Reduce el tamaño y vuelve a intentarlo.';
  }
  if (/no photo file/i.test(raw)) return 'No se recibió ninguna foto.';
  if (/member not found/i.test(raw)) return 'Miembro no encontrado.';
  if (raw) return raw;
  return 'Error al subir foto.';
}

export function useAdminVerificationPhoto() {
  const qc = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: upload,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['team-members'] });
      qc.invalidateQueries({ queryKey: ['team-members-admin'] });
      qc.invalidateQueries({ queryKey: ['approacher'] });
      toast('Foto actualizada', 'success');
    },
    onError: (err) => toast(uploadErrorMessage(err), 'error'),
  });
}
